import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycArticle81GuardianshipPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-article-81-guardianship/']} />;
}
